import { AnimationStyles, mergeStyles } from "@fluentui/react";

export const animatedDivClass = mergeStyles(
    {},
    AnimationStyles.fadeIn200
  )